import { LyaAutoInterviewCandidateMeta } from './lya.types';

export class LyaActions {
  static readonly anonyme = class {
    static readonly type = '[lya] anonyme action';
  };

  static readonly getCandidateInterviewMeta = class {
    static readonly type = '[lya] get candidate interview meta';
    constructor(
      public id: string,
      public companyId?: string,
    ) {}
  };

  static readonly sendCV = class {
    static readonly type = '[lya] send cv';
    constructor(public file: File) {}
  };

  static readonly getCompanyLogo = class {
    static readonly type = '[lya] get company logo';
    constructor(public companyId: string) {}
  };

  static readonly setConversationQuestionsMeta = class {
    static readonly type = '[lya] set conversation meta';
    constructor(public data: LyaAutoInterviewCandidateMeta) {}
  };

  static readonly nextQuestion = class {
    static readonly type = '[lya] next question';
  };

  static readonly cleanQuestions = class {
    static readonly type = '[lya] clean questions';
  };

  static readonly setTranscriptionResponse = class {
    static readonly type = '[lya] set transcription response';
    constructor(public data: string) {}
  };

  static readonly terminateConversation = class {
    static readonly type = '[lya] terminate conversation';
  };
}
